export const apiPath = '/v2/email_logs';

const actionType = 'EMAIL_LOGS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
